import type { JourneyResetAction } from '../types/actions'
import { SUBMISSION_STATUS } from '../types/enums'

import { actionFactory } from './factory'

export const journeyReset = actionFactory<JourneyResetAction>((state) => {
  state.blockValues = {}
  state.logicsEngine = {
    history: [],
    locked: false
  }
  state.navigatedPath = []
  state.submissionState = {
    status: SUBMISSION_STATUS.IDLE
  }
}, 'journeyReset')
